/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { labels } from '@umati/dashboard-common';
import { IMachine } from '@umati/dashboard-types';
import React, { ReactElement } from 'react';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import { usePubSubNode, usePubSubValue } from 'utilities/PubSub/PubSubHooks';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import StatusTimeline from 'components/timeline/StatusTimeline';
import DetailGalleryPubSub from './DetailGalleryPubSub';
import MachineHandling from 'utilities/MachineHandling';

interface IImageAndTimelinePubSubProps {
  templateContext: TemplateContext;
  machine: IMachine;
}

export default function ImageAndTimelinePubSub(props: IImageAndTimelinePubSubProps): ReactElement {
  const template = props.templateContext.template;

  const filterDefaultImagePathClassifier = TemplateHelperPubSub.createFilter(
    props.templateContext.namespaces,
    template.imagesConfig.defaultImagePathClassifierVariable?.variablePath,
  );
  const nodeDefaultImagePathClassifier = usePubSubNode(filterDefaultImagePathClassifier);
  const valueDefaultImagePathClassifier = usePubSubValue(nodeDefaultImagePathClassifier);

  const machine = props.machine;
  return (
    <div className="row mb-4">
      <div className="col-12 col-lg-5">
        <DetailGalleryPubSub
          templateContext={props.templateContext}
          imagePath={machine?.ImagePath!}
          machineId={machine.MachineId}
          defaultImagePathClassifier={valueDefaultImagePathClassifier}
          machineType={machine.TypeDefinition}
        />
      </div>
      <div className="col-12 col-lg-7">
        {template.timeline && (
          <div className="mb-1 mb-md-2 mb-lg-4">
            <h3 className="h5">
              Encoding v{MachineHandling.getEncodingVersion(machine) || 'NotSet'} | {labels.statusOverview}
            </h3>
            <div className="status-timeline">
              <StatusTimeline
                namespaceUri={machine.MachineId}
                colorMap={TemplateHelperPubSub.getTimelineColorMap(template.timeline)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
